import NicheLandingPage from "@/pages/NicheLandingPage";

const HERO = "https://images.unsplash.com/photo-1600531529272-023c4b821f14?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBidWlsZGluZyUyMGV4dGVyaW9yJTIwZ2xhc3MlMjBtb2Rlcm58ZW58MHx8fHwxNzgxMTkxMDgwfDA&ixlib=rb-4.1.0&q=85";

export const I75Landing = () => (
  <NicheLandingPage
    slug="office-space-near-i-75-weston"
    metaTitle="Office Space Near I-75 in Weston, FL"
    metaDescription="Office space minutes from I-75 in Weston, FL — easy commute from Davie, Sunrise, Pembroke Pines, Coral Springs and Miami. Furnished suites, covered parking and 24/7 access."
    h1="Office space near I-75 in Weston, FL."
    intro="Two minutes from the I-75 / Royal Palm Boulevard interchange and a short drive from the Sawgrass Expressway — a commute that works for the people you employ and the clients you visit, across west Broward and into Miami-Dade."
    audience={[
      "Teams commuting from Pembroke Pines, Davie, Sunrise",
      "Firms hosting Miami / Boca clients regularly",
      "Sales orgs with field travel across South Florida",
      "Remote-first teams returning to a central hub",
    ]}
    benefits={[
      { title: "2 min to I-75", body: "Direct access via Royal Palm Boulevard — most days you're on the freeway before your coffee cools." },
      { title: "6 min to Sawgrass Expressway", body: "Clear shot to Coral Springs, Boca Raton and the Fort Lauderdale airports." },
      { title: "Covered tenant parking", body: "Reserved spaces for your team and visitor parking at the front of the building." },
      { title: "Hotel partners nearby", body: "Four national hotel brands within a mile — convenient for visiting clients and recruits." },
      { title: "Walkable lunch options", body: "Sixteen restaurants and three coffee bars within a 5-minute walk." },
      { title: "EV charging", body: "Charging stations a short walk away for tenants and their guests." },
    ]}
    recommendedSlugs={["executive-suites", "office-suites", "team-offices"]}
    heroImage={HERO}
    defaultOfficeType="Office Suites"
  />
);

export default I75Landing;
